import { createFileRoute } from "@tanstack/react-router";
import SegmentLanding from "@/pages/SegmentLanding";
import { segmentPages } from "@/config/segmentPages";

const config = segmentPages.find((page) => page.path === "kostenlose-kreditkarte")!;

export const Route = createFileRoute("/kostenlose-kreditkarte")({
  head: () => ({
    meta: [
      { title: config.seoTitle },
      { name: "description", content: config.seoDescription },
      { property: "og:title", content: config.seoTitle },
      { property: "og:description", content: config.seoDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.kreditkarten.de/kostenlose-kreditkarte" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://www.kreditkarten.de/kostenlose-kreditkarte" }],
  }),
  component: () => <SegmentLanding config={config} />,
});
